import { BuildConfig } from "./BuildConfig";

export const followUpOrthoExtremitiesBuildConfig: BuildConfig = {
  actionsOrder: ["pick"],
  pick: {
    topLevelSections: {
      textIds: ["PATIENT COMFORT ASSESSMENT GUIDE (ORTHO)"],
    },
  },
} as const;
